<script setup lang="ts">
	import PinnacleLogo from '@/components/logos/PinnacleLogo.vue'
</script>

<template>
	<div class="navbar-brand me-1 me-sm-3">
		<RouterLink to="/">
			<div class="d-flex align-items-center wrapperClass" style="width: 150px">
				<PinnacleLogo />
			</div>
		</RouterLink>
	</div>
</template>
